import { NgModule } from '@angular/core';
import { PfeNavigateActionService } from './navigate-action.service';
import { PfeActionsService } from '../pfe-actions.service';
import { PfeNavigateActionType } from './navigate-action.model';

@NgModule({
  providers: [PfeNavigateActionService],
})
export class PfeNavigateActionModule {
  constructor(
    private pfeActionsService: PfeActionsService,
    pfeNavigateActionService: PfeNavigateActionService
  ) {
    this.pfeActionsService.registerAction(PfeNavigateActionType, pfeNavigateActionService.navigate);
  }
}
